import { gql } from '@apollo/client';
import { productNotificationFragment } from 'approot/classes/classes.graphql';
import { unitDetailsFragment } from 'approot/unit/unit.graphql';

export const GET_USER_NOTIFICATIONS = gql`
  query GetUserNotifications {
    user {
      id
      accountStatus
      isSchoolTeacher
      notifications {
        contentReleaseNotifications {
          contentId
          contentType
          detail {
            ...UnitDetailsFragment
          }
          dismissed
        }
        productNotifications {
          ...ProductNotificationFragment
        }
      }
    }
  }
  ${unitDetailsFragment}
  ${productNotificationFragment}
`;

export const DISMISS_CONTENT_RELEASE_NOTIFICATION = gql`
  mutation DimissUserContentReleaseNotification(
    $input: DismissUserContentReleaseNotificationInput!
  ) {
    dismissUserContentReleaseNotification(input: $input) {
      contentId
      contentType
      dismissed
    }
  }
`;
